const STATUS = {
  complete: 'complete',
  error: 'error'
};

export const injectScriptTag = (src) => {
  return new Promise((resolve, reject) => {
    let resolved = false;
    let errored = false;

    const tag = document.createElement('script');
    tag.type = 'text/javascript';
    tag.async = false;

    const handleLoad = () => {
      resolved = true;
      return resolve(src);
    };

    const handleReject = () => {
      errored = true;
      return reject(src);
    };

    tag.onreadystatechange = () => {
      if (resolved) {
        return handleLoad();
      }
      if (errored) {
        return handleReject();
      }
      const state = tag.readyState;
      if (state === STATUS.complete) {
        handleLoad();
      } else if (state === STATUS.error) {
        handleReject();
      }
    };

    tag.addEventListener('load', handleLoad);
    tag.addEventListener('error', handleReject);
    tag.src = src;
    document.body.appendChild(tag);
    return tag;
  });
};



// WEBPACK FOOTER //
// ./helpers/loadScript.helper.js